import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
import querystring from 'querystring'

const giftCardApi = {
  list (params) {
    return axios.get(
      `${ApiSetting.baseUrl}/api/giftcards/`, {params: params}
    )
  },
  detail (giftCardId, params) {
    // 详情
    return axios.get(
      `${ApiSetting.baseUrl}/api/giftcards/${giftCardId}/`,
      {params: params}
    )
  },
  create (params) {
    // 创建新赞
    return axios.post(
      `${ApiSetting.baseUrl}/api/giftcards/`, querystring.stringify(params)
    )
  }
}

export default giftCardApi
